import SelectedPaymentOptionView from '@akinon/next/components/selected-payment-option-view';
import { useAppDispatch, useAppSelector } from '@akinon/next/redux/hooks';
import { CheckoutPaymentOption } from '@akinon/next/types';
import clsx from 'clsx';
import { RootState } from '@theme/redux/store';
import PaymentOptionButtons from './payment-option-buttons';
import { Button, Icon, Radio } from '@theme/components';
import { useLocalization, usePaymentOptions } from '@akinon/next/hooks';
import { useMemo } from 'react';
import { useSetPaymentOptionMutation } from '@akinon/next/data/client/checkout';
import { setInstallmentOptionsOpen } from '@theme/redux/reducers/installmentOptions';
import { goToStep } from '@theme/redux/reducers/checkoutStepper';

export const PaymentOptionViews: Array<CheckoutPaymentOption> = [];

const PaymentStep = () => {
  const dispatch = useAppDispatch();
  const { preOrder, attributeBasedShippingOptions } = useAppSelector(
    (state: RootState) => state.checkout
  );

  const isPaymentStepBusy = useAppSelector(
    (state: RootState) => state.checkout.steps.payment.busy
  );

  const [setPaymentOption] = useSetPaymentOptionMutation();
  const { filteredPaymentOptions } = usePaymentOptions();

  const onClickHandler = (option: CheckoutPaymentOption) => {
    setPaymentOption(option.pk);
  };
  const { t } = useLocalization();

  const displayedPaymentOptions = useMemo(() => {
    if (
      attributeBasedShippingOptions &&
      Object.keys(attributeBasedShippingOptions).length > 0
    ) {
      return filteredPaymentOptions.filter(
        (option) => option.slug.toLowerCase() !== 'pay-on-delivery'
      );
    }

    return filteredPaymentOptions;
  }, [filteredPaymentOptions, attributeBasedShippingOptions]);

  return (
    <div className="px-3 py-6 flex flex-col divide-y divide-[#CDCFCE] xl:py-10 xl:px-6">
      {displayedPaymentOptions.map((option) => (
        <div
          key={`payment-option-${option.pk}`}
          data-id={`payment-option-${option.pk}`}
        >
          <div className="flex items-center justify-between">
            <h3 className="text-lg/none font-medium xl:text-xl/none">
              {option.name}
            </h3>
            <Icon
              name={
                preOrder.payment_option?.pk === option.pk ? 'minus' : 'plus'
              }
              size={24}
              className="py-0 px-3 border border-primary-black rounded-[50px] h-10 flex items-center justify-center"
            />
          </div>

          {preOrder.payment_option?.pk === option.pk && (
            <SelectedPaymentOptionView />
          )}
        </div>
      ))}

      <div className="pt-6">
        <Button
          onClick={() => dispatch(goToStep('DELIVERY'))}
          className="h-11 rounded-[50px] bg-white !text-primary-black border border-primary-black text-sm/none px-7 hover:bg-primary-black hover:!text-white xl:h-16 xl:px-10"
        >
          {t('checkout.page.back')}
        </Button>
      </div>
    </div>
  );
};

export default PaymentStep;
